/**
 * useEmbeddedBrowserYield — hold the embedded browser's yield while an
 * overlay that must render above the pane rect is open (onboarding tour,
 * command menu, dialogs, dropdowns). The shell's CEF view is a native child
 * window, so page-rendered overlays cannot win the z-order on their own —
 * the shell has to step the pane back.
 *
 * Inert outside the desktop shell (the underlying invoke is a no-op without
 * `window.__TAURI__`), so callers wire it unconditionally.
 */
import { useEffect } from "react";
import { acquireEmbeddedBrowserYield } from "@/lib/embedded-browser";

export function useEmbeddedBrowserYield(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    return acquireEmbeddedBrowserYield();
  }, [active]);
}
